/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HoldsConfirmBatchRequest
 */
export interface HoldsConfirmBatchRequest {
    /**
     * Array of hold IDs to confirm
     * @type {Array<string>}
     * @memberof HoldsConfirmBatchRequest
     */
    holdIds: Array<string>;
}

/**
 * Check if a given object implements the HoldsConfirmBatchRequest interface.
 */
export function instanceOfHoldsConfirmBatchRequest(value: object): value is HoldsConfirmBatchRequest {
    if (!('holdIds' in value) || value['holdIds'] === undefined) return false;
    return true;
}

export function HoldsConfirmBatchRequestFromJSON(json: any): HoldsConfirmBatchRequest {
    return HoldsConfirmBatchRequestFromJSONTyped(json, false);
}

export function HoldsConfirmBatchRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): HoldsConfirmBatchRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'holdIds': json['hold_ids'],
    };
}

  export function HoldsConfirmBatchRequestToJSON(json: any): HoldsConfirmBatchRequest {
      return HoldsConfirmBatchRequestToJSONTyped(json, false);
  }

  export function HoldsConfirmBatchRequestToJSONTyped(value?: HoldsConfirmBatchRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hold_ids': value['holdIds'],
    };
}

